export enum DriverStatus {
  Inactive = 'inactive',
  Active = 'active',
  InviteSend = 'inviteSend'
}